/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AnalyticsSignalDefinitionSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AnalyticsSignalDefinitionRequest = {
  sensorId: string;
  definitionHash: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type AnalyticsSignalDefinitionSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AnalyticsSignalDefinitionSecurity$outboundSchema: z.ZodMiniType<
  AnalyticsSignalDefinitionSecurity$Outbound,
  AnalyticsSignalDefinitionSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function analyticsSignalDefinitionSecurityToJSON(
  analyticsSignalDefinitionSecurity: AnalyticsSignalDefinitionSecurity,
): string {
  return JSON.stringify(
    AnalyticsSignalDefinitionSecurity$outboundSchema.parse(
      analyticsSignalDefinitionSecurity,
    ),
  );
}

/** @internal */
export type AnalyticsSignalDefinitionRequest$Outbound = {
  sensor_id: string;
  definition_hash: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const AnalyticsSignalDefinitionRequest$outboundSchema: z.ZodMiniType<
  AnalyticsSignalDefinitionRequest$Outbound,
  AnalyticsSignalDefinitionRequest
> = z.pipe(
  z.object({
    sensorId: z.string(),
    definitionHash: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sensorId: "sensor_id",
      definitionHash: "definition_hash",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function analyticsSignalDefinitionRequestToJSON(
  analyticsSignalDefinitionRequest: AnalyticsSignalDefinitionRequest,
): string {
  return JSON.stringify(
    AnalyticsSignalDefinitionRequest$outboundSchema.parse(
      analyticsSignalDefinitionRequest,
    ),
  );
}
